import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';
import { Home, Search, Heart, ShoppingBag, User } from 'lucide-react';

export const MobileBottomNav = () => {
  const location = useLocation();
  const { cartCount, openDrawer } = useCart();
  const { user } = useAuth();
  const path = location.pathname;

  if (['/admin', '/checkout', '/login', '/register'].some(p => path.startsWith(p))) return null;

  const handleCartClick = (e) => {
    e.preventDefault();
    openDrawer();
  };

  const items = [
    { to: '/', icon: Home, label: 'Home' },
    { to: '/shop', icon: Search, label: 'Shop' },
    { to: user ? '/wishlist' : '/login', icon: Heart, label: 'Wishlist' },
    { to: '#cart', icon: ShoppingBag, label: 'Bag', badge: cartCount, onClick: handleCartClick },
    { to: user ? '/my-orders' : '/login', icon: User, label: 'Account' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[#E2E2E2] sm:hidden safe-bottom" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around h-14">
        {items.map(({ to, icon: Icon, label, badge, onClick }) => {
          const isActive = !onClick && (path === to || (to !== '/' && path.startsWith(to)));
          const Comp = onClick ? 'button' : Link;
          const props = onClick ? { onClick } : { to };
          return (
            <Comp
              key={label}
              {...props}
              className={`flex flex-col items-center justify-center gap-0.5 w-full h-full relative transition-colors btn-icon ${
                isActive ? 'text-[#0A0A0A]' : 'text-[#999]'
              }`}
              data-testid={`bottom-nav-${label.toLowerCase()}`}
            >
              <div className="relative">
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2 : 1.5} />
                {badge > 0 && (
                  <span className="absolute -top-1.5 -right-2 bg-[#C9A84C] text-white text-[8px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                    {badge > 9 ? '9+' : badge}
                  </span>
                )}
              </div>
              <span className={`text-[9px] tracking-wider ${isActive ? 'font-bold' : 'font-medium'}`}>{label}</span>
              {isActive && <div className="absolute top-0 left-1/2 -translate-x-1/2 w-6 h-0.5 bg-[#0A0A0A] rounded-b" />}
            </Comp>
          );
        })}
      </div>
    </nav>
  );
};
